import { ForwardRefExoticComponent, RefAttributes } from 'react';

import {
  IconFaceMask,
  IconFlag,
  IconGenderBigender,
  IconPill,
  IconProps,
  IconSitemap,
  IconStethoscope,
  IconUsers,
  IconVirus,
  IconWheelchair,
} from '@tabler/icons-react';

import {
  PermissionString,
  Roles,
  UserWithPermissions,
} from '@interfaces/users.interface';

/**
 * Special link placeholders:
 * :userId
 * :medicalOrganizationId
 * :medicalDoctorId
 */

export const linksData: (
  | {
      type: 'link';
      label: string;
      icon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;
      link: string;
      requiredPermission?: PermissionString;
      excludeRoles?: Roles[];
      relatedOnly?: boolean;
    }
  | {
      type: 'divider';
      dividerLabel: string;
      requiredPermission?: PermissionString;
      excludeRoles?: Roles[];
      relatedOnly?: boolean;
    }
)[] = [
  {
    type: 'divider',
    dividerLabel: 'Amministrazione',
    excludeRoles: ['medicalOrganization', 'medicalDoctor'],
  },
  // {
  //   type: 'link',
  //   label: 'Dashboard',
  //   icon: IconDashboard,
  //   link: '/',
  // },
  {
    type: 'link',
    label: 'Utenti',
    icon: IconUsers,
    link: '/utenti',
    requiredPermission: 'USERS.READ',
  },
  {
    type: 'link',
    label: 'Organizzazioni mediche',
    icon: IconSitemap,
    link: '/organizzazioni-mediche',
    requiredPermission: 'MEDICAL_ORGANIZATIONS.READ',
    relatedOnly: false,
  },
  {
    type: 'link',
    label: 'Organizzazione medica',
    icon: IconSitemap,
    link: '/organizzazioni-mediche/:medicalOrganizationId',
    requiredPermission: 'MEDICAL_ORGANIZATIONS.READ',
    relatedOnly: true,
  },
  {
    type: 'link',
    label: 'Medici',
    icon: IconFaceMask,
    link: '/medici',
    requiredPermission: 'MEDICAL_DOCTORS.READ',
    excludeRoles: ['medicalDoctor'],
  },
  {
    type: 'link',
    label: 'Medico',
    icon: IconFaceMask,
    link: '/medici/:medicalDoctorId',
    requiredPermission: 'MEDICAL_DOCTORS.READ',
    excludeRoles: ['admin', 'medicalOrganization'],
  },
  {
    type: 'link',
    label: 'Pazienti',
    icon: IconWheelchair,
    link: '/pazienti',
    requiredPermission: 'PATIENTS.READ',
  },
  // {
  //   type: 'link',
  //   label: 'Terapie',
  //   icon: IconClipboardHeart,
  //   link: '/terapie',
  //   requiredPermission: 'THERAPIES.READ',
  //   relatedOnly: false,
  // },
  {
    type: 'divider',
    dividerLabel: 'Tassonomie',
    excludeRoles: ['medicalOrganization', 'medicalDoctor'],
  },
  {
    type: 'link',
    label: 'Specialità mediche',
    icon: IconStethoscope,
    link: '/specialità-mediche',
    requiredPermission: 'MEDICAL_SPECIALITIES.MANAGE',
  },
  {
    type: 'link',
    label: 'Generi',
    icon: IconGenderBigender,
    link: '/generi',
    requiredPermission: 'GENDERS.MANAGE',
  },
  {
    type: 'link',
    label: 'Patologie',
    icon: IconVirus,
    link: '/patologie',
    requiredPermission: 'PATHOLOGIES.MANAGE',
  },
  {
    type: 'link',
    label: 'Etnie',
    icon: IconFlag,
    link: '/etnie',
    requiredPermission: 'ETHNICITIES.MANAGE',
  },
  {
    type: 'link',
    label: 'Farmaci',
    icon: IconPill,
    link: '/farmaci',
    requiredPermission: 'DRUGS.MANAGE',
  },
];

export const getLink = (link: string, user: UserWithPermissions | null) => {
  if (!user) return link;

  return link
    .replaceAll(':userId', user.id)
    .replaceAll(':medicalOrganizationId', user.medicalOrganizationId || '')
    .replaceAll(':medicalDoctorId', user.medicalDoctorId || '');
};
